module.exports = __webpack_public_path__ + "static/media/rhs_circle.c5ef2311.svg";